<template>
  <div class="view-page">
    <main-center>
      <router-view />
    </main-center>
  </div>
</template>
<script type="text/javascript">
import mainCenter from "../components/mainContent/index";

export default {
  name: "page",
  components: {
    mainCenter,
  },
  mounted() {},
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/pages/Index.vue